import { EModule } from 'src/app/project/shared/enums/module.enum';
import {
  excelOutput,
  PDFFullReport,
  pdfIndividualReport,
  pdfSingleIndividualReport,
  PDFSummary,
  sitePlanPDF,
  TExportTypeGroup,
  wordFullReport,
  wordIndividual,
} from '../point-export-modal/export-types';

export function getExportTypesByModule(module: EModule): TExportTypeGroup[] {
  switch (module) {
    case 'SITE':
      return [
        {
          label: 'summary',
          description: 'summary_tooltip',
          items: [PDFSummary],
        },
        {
          label: 'full_report',
          description: 'full_report_tooltip',
          items: [PDFFullReport, excelOutput, wordFullReport],
        },
        {
          label: 'individual_reports_zip',
          description: 'individual_reports_tooltip',
          items: [pdfIndividualReport],
        },
        {
          label: 'site_plan',
          description: 'site_plan_tooltip',
          items: [sitePlanPDF],
        },
      ];
    case 'OVERVIEW':
      return [
        {
          label: 'full_report',
          description: 'full_report_tooltip',
          items: [PDFFullReport, excelOutput],
        },
        {
          label: 'individual_reports_zip',
          description: 'individual_reports_tooltip',
          items: [wordIndividual, PDFSummary],
        },
      ];
    case 'POINT':
      return [
        {
          label: 'full_report',
          description: 'individual_reports_tooltip',
          items: [pdfSingleIndividualReport, wordFullReport],
        },
      ];
  }
}
